














































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace, State } from "vuex-class";
import { ApplicationState, IPRCFilter } from "@/models";
import RateChangesModule from "@/store/modules/rate-changes";

const rateChanges = namespace(RateChangesModule.name);

@Component({
  name: "UnitType"
})
export default class UnitType extends Vue {
  // ===== Store ===== //
  @State("application") private readonly application!: ApplicationState;
  @rateChanges.Action private applyFilter!: (filter: IPRCFilter) => void;
  // ===== Props ===== //
  @Prop(Number) private readonly filter!: number;
  // ===== Data ===== //
  private selectedUnitTypes: string[] = [];
  // ===== Methods ===== //
  public toggleSelectAll(): void {
    this.$nextTick(() => {
      if (this.selectedSomeUnitTypes || this.selectedAllUnitTypes) {
        this.selectedUnitTypes = [];
      } else {
        this.selectedUnitTypes = this.application.facilityUnitTypes;
      }
    });
  }
  public generateQueryString(): string {
    const queryString: string[] = [];
    this.selectedUnitTypes.forEach(unitType => {
      queryString.push(`facilities_unit_type[in][]=${unitType}`);
    });
    return queryString.join("&");
  }
  @Watch("selectedUnitTypesParameter")
  public handleSelectedUnitTypes(selectedUnitTypesParameter: IPRCFilter): void {
    this.applyFilter(selectedUnitTypesParameter);
  }
  // ===== Computed ===== //
  get selectedAllUnitTypes(): boolean {
    return this.selectedUnitTypes.length === this.application.facilityUnitTypes.length;
  }
  get selectedSomeUnitTypes(): boolean {
    return !!(this.selectedUnitTypes.length && !this.selectedAllUnitTypes);
  }
  get checkboxIcon(): string {
    if (this.selectedAllUnitTypes) {
      return "check_box";
    } else if (this.selectedSomeUnitTypes) {
      return "indeterminate_check_box";
    }
    return "check_box_outline_blank";
  }
  get unitTypeText(): string {
    if (this.selectedAllUnitTypes) {
      return "All Unit Types";
    } else if (this.selectedUnitTypes.length > 2) {
      const firstTwo = this.selectedUnitTypes.slice(0, 2).join(", ");
      const truncatedNumber = this.selectedUnitTypes.length - 2;
      return `${firstTwo}, (+ ${truncatedNumber} unit type${truncatedNumber > 1 ? "s" : ""})`;
    } else {
      return this.selectedUnitTypes.join(", ");
    }
  }
  get selectedUnitTypesParameter(): IPRCFilter {
    return {
      id: this.filter,
      chipText: `Unit Type is ${this.unitTypeText}`,
      operator: "[in][]",
      value: this.selectedUnitTypes.join(","),
      query: this.generateQueryString()
    };
  }
}
